export default __webpack_public_path__ + "static/media/Self_Defence3.3b0ec617.jpg";